import { __exports as PresentationProvider } from './_virtual-PresentationProvider.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireContainer } from './vp-js-token-engine-build-tokenGenerators-infrastructure-container.js';

var hasRequiredPresentationProvider;

function requirePresentationProvider () {
	if (hasRequiredPresentationProvider) return PresentationProvider;
	hasRequiredPresentationProvider = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(PresentationProvider, "__esModule", {
	  value: true
	});
	PresentationProvider.default = void 0;
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var _container = requireContainer();
	let PresentationProvider$1 = class PresentationProvider {
	  constructor(culture, tenant) {
	    (0, _defineProperty2.default)(this, "tokenEngine", void 0);
	    this.tokenEngine = _container.tokenEngineFactory.create(culture, tenant);
	  }
	  async get(priceData, presentationType) {
	    let token;
	    try {
	      token = _container.presentationTokenFactory.generateToken(priceData, presentationType);
	    } catch (e) {
	      return Promise.reject(e);
	    }
	    return await this.tokenEngine.render(token);
	  }
	};
	PresentationProvider.default = PresentationProvider$1;
	
	return PresentationProvider;
}

export { requirePresentationProvider as __require };
//# sourceMappingURL=vp-js-token-engine-build-tokenGenerators-PresentationProvider.js.map
